<template lang="pug">
  div(:class="b()")
    item(
      v-for="item, idx in items"
      ref="items"
      :key="item.value"
      :selected="isSelected(item)"
      :item="item"
      @click="args => onClickItem(args, idx)"
    )
</template>

<script>
  import Item from './product-choice-item';

  export default {
    name: 'product-choice',

    props: {
      value: { type: Object },
      items: {type: Array, default: () => [] },
      disabled: { type: Boolean, default: false },
    },

    methods: {
      onClickItem(item, index) {
        if(this.disabled) return;

        this.$emit('input', item);
        this.scrollToProduct(index)
      },

      isSelected(item) {
        return this.value?.value === item?.value;
      },

      scrollToProduct(index) {
        const item = this.$refs.items[index].$el;
        const parent = this.$el;

        this.$el.scrollLeft = (item.offsetLeft - 20) + (item.offsetWidth / 2) - (parent.offsetWidth / 2);
      },
    },

    mounted() {
      const { scrollWidth, offsetWidth } = this.$el;

      if(scrollWidth > offsetWidth)
        this.$el.scrollLeft = (scrollWidth - offsetWidth) / 2;
    },

    components: {
      Item,
    },
  };
</script>

<style lang="sass" scoped>
  @import '~@/sass/mixins'

  .product-choice
    margin: 0 auto
</style>